import { ProductDiagnosticContext } from "@/types/product-diagnostic-context";
import { deleteData, getData, postData, putData } from "./axios-service";
import { ProductMake, ProductType } from "@/types";

function productDiagnosticContextMapper(inputProductDiagnosticContext: any): ProductDiagnosticContext {
    return {
        id: inputProductDiagnosticContext.id,
        productType: inputProductDiagnosticContext.productType,
        productMake: inputProductDiagnosticContext.productMake,
        errorCodes: inputProductDiagnosticContext.errorCodes || []

    };
}

export function productDiagnosticContextMapperArray(inputArray: any[]): ProductDiagnosticContext[] {
    return inputArray.map(productDiagnosticContextMapper);
}


export async function postProductDiagnosticContext(context: ProductDiagnosticContext): Promise<ProductDiagnosticContext> {
    const response = await postData("/product-diagnostic-contexts", context);
    return productDiagnosticContextMapper(response);
}

export async function fetchProductDiagnosticContexts(): Promise<ProductDiagnosticContext[]> {
    const contexts  = await getData<ProductDiagnosticContext[]>("/product-diagnostic-contexts");
    return productDiagnosticContextMapperArray(contexts ?? []);
}

export async function fetchFilteredProductDiagnosticContexts(productMake?: ProductMake, productType?: ProductType): Promise<ProductDiagnosticContext[]> {
    const params = new URLSearchParams();

    if (productMake) {
        params.set("product_make", productMake);
    }

    if (productType) {
        params.set("product_type", productType);
    }

    const query = params.toString();
    const url = query ? `/product-diagnostic-contexts?${query}` : "/product-diagnostic-contexts";

    const response = await getData<ProductDiagnosticContext[]>(url);
    return productDiagnosticContextMapperArray(response ?? []);
}

export function fetchProductDiagnosticContextById(id: string): Promise<ProductDiagnosticContext> {
    return getData("/product-diagnostic-contexts/" + id).then(
        onSucceed => {
            return productDiagnosticContextMapper(onSucceed);
        }
    );
}

export function putProductDiagnosticContext(context: ProductDiagnosticContext): Promise<any> {
    return putData("/product-diagnostic-contexts/" + context.id, context);
}

export function deleteProductDiagnosticContext(id: string): Promise<any> {
    return deleteData("/product-diagnostic-contexts/" + id);
}
